import { Badge } from '@optools/components/ui/badge';
import { EsniRuleType } from '@optools/services/operator-gateway/types/generated/graphql';
import { ReactNode } from '@tanstack/react-router';
import { startCase } from 'es-toolkit';
import { UserCheck, UserLock } from 'lucide-react';
import { ComponentProps } from 'react';

const TYPE_BADGE_VARIANTS: Record<
  EsniRuleType,
  { icon: ReactNode; variant: ComponentProps<typeof Badge>['variant'] }
> = {
  [EsniRuleType.BLACKOUT]: {
    icon: <UserLock />,
    variant: 'outline',
  },
  [EsniRuleType.ENTITLEMENT]: {
    icon: <UserCheck />,
    variant: 'secondary',
  },
};

export function ESNIRuleTypeBadge({ type }: { type: EsniRuleType }) {
  const { icon, variant } = TYPE_BADGE_VARIANTS[type];
  return (
    <Badge variant={variant}>
      {icon}
      {startCase(type)}
    </Badge>
  );
}
